import {
  AcceptPendingGroupJoinRequestMailRequest,
  DenyPendingGroupJoinRequestMailRequest,
  GrapevineGroupEventsApi
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useCallback, useMemo } from 'react';
import { handleError } from 'utils';
import { useGetDDServiceApiConfiguration } from './dd.service';

export const useGroupApi = () => {
  const configuration = useGetDDServiceApiConfiguration();
  const apiInstance = useMemo(
    () => new GrapevineGroupEventsApi(configuration),
    [configuration]
  );

  const acceptPendingGroupJoinRequest = useCallback(
    (requestParameters: AcceptPendingGroupJoinRequestMailRequest) =>
      apiInstance
        .acceptPendingGroupJoinRequestMail(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  const denyPendingGroupJoinRequest = useCallback(
    (requestParameters: DenyPendingGroupJoinRequestMailRequest) =>
      apiInstance
        .denyPendingGroupJoinRequestMail(requestParameters)
        .catch(handleError),
    [apiInstance]
  );

  return {
    acceptPendingGroupJoinRequest,
    denyPendingGroupJoinRequest
  };
};
